<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 40 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="h-4 w-4"
  >
    <path
      d="M39.3606 1.9747L38.0504 0.6553C37.638 0.2433 37.0894 0.0163002 36.5031 0.0163002C35.917 0.0163002 35.3678 0.2433 34.9554 0.6553L20.0089 15.6024L5.0452 0.6387C4.6335 0.2267 4.0843 0 3.49824 0C2.91222 0 2.36262 0.2267 1.95059 0.6387L0.640013 1.9499C-0.213337 2.8026 -0.213337 4.1916 0.640013 5.0443L18.4561 22.9244C18.8678 23.3361 19.4164 23.6262 20.0076 23.6262H20.0145C20.6008 23.6262 21.1494 23.3358 21.5612 22.9244L39.3606 5.0927C39.773 4.681 39.9993 4.1158 40 3.5298C40 2.9434 39.773 2.386 39.3606 1.9747Z"
      fill="currentColor"
    />
  </svg>
</template>
